import type { DashboardState } from '../index';

export const setOpenMenu = (state: DashboardState) => {
  state.menuOpened = !state.menuOpened;
};
